'use client';

import { useEffect } from 'react';
import { clarityProjectId } from '@/lib/env';
import { sendGAEvent } from '@next/third-parties/google';
import { SpeedInsights } from '@vercel/speed-insights/next';
import MSClarity from '@microsoft/clarity';

export default function AnalyticsAndInsights({ locale }: { locale: string }) {
  useEffect(() => {
    MSClarity.init(clarityProjectId);
    MSClarity.setTag('locale', locale);

    setTimeout(() => {
      sendGAEvent('set', 'language', locale);
    }, 100);
  }, [locale]);

  return <SpeedInsights />;
}
